import styled from 'styled-components'
import theme from '../../theme/theme';

export const CardWrapper = styled.div`
  padding: 20px;
  width: auto;
  max-width: 500px;
  font-family: 'Inter', sans-serif;
`;

export const CardTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${theme.color.navy};
  margin: 0;
  margin-bottom: 20px;
`;

export const BookingDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`; 

export const CrossContainer = styled.div`
    position: fixed;
    top: 20px;
    right: 20px;
    cursor: pointer;
`;
